import { css } from "styled-components";
import {
  Container,
  Input,
  IsRequiredStar,
  Label,
  Select,
  Span,
} from "../../Styles/Global.Styled";
import { inputChangehandlers } from "../../helpers/formHandlers";

const labelStyle = css`
  position: absolute;
  height: 1.3vh;
  top: -1vh;
  left: 1vh;
  background-color: white;
  font-size: 1.5vh;
  z-index: 2;
`;

const selectStyle = css`
  padding-left: 0.5vh;
  border-radius: 12px 0 0 12px;
  z-index: 1;
  font-size: 1.5vh;
  border-right: none;
`;

const inputStyle = css`
  width: 100%;
  padding: 0 0.5vh;
  border-radius: 0 12px 12px 0;
  z-index: 1;
  border-left: none;
`;

const errorTxt = css`
  position: absolute;
  color: red;
  bottom: -2vh;
  left: 0;
  font-size: 1.25vh;
`;

const PhoneNumberInput = ({
  setForm,
  txtProps,
  selectProps,
  cntryCodeIndex,
  phoneNoIndex,
}) => {

  const cnt = css`
    height: ${selectProps.height};
    width: ${selectProps.width};
    `;
  const mbCnt = css`
    height: ${selectProps.mHeight};
    width: ${selectProps.mWidth};
  `;

  const runTxtValidation = () => {
    const handler = inputChangehandlers[txtProps.handleValidation];
    if (handler) {
      handler(setForm, txtProps, phoneNoIndex);
    }
  };

  const handleTxtChange = (e) => {
    const { value } = e.target;

    const handler = inputChangehandlers[txtProps.onChangeHandler];
    if (handler) {
      handler(setForm, phoneNoIndex, value);
    }

    if (txtProps.errors !== null) {
      runTxtValidation();
    }
  };

  const handleSelectChange = (e) => {
    const newValue = e.target.value;
    setForm((prev) => {
      const updatedForm = [...prev];
      updatedForm[cntryCodeIndex].value = newValue;
      return updatedForm;
    });
  };

  return (
    <Container $baseStyle={cnt} $mStyle={mbCnt}>
      <Label $baseStyle={labelStyle}>
        {txtProps.label}
        {txtProps.required && <IsRequiredStar />}
      </Label>
      <Select
        $error={txtProps.errors}
        $baseStyle={selectStyle}
        value={selectProps.value}
        id={selectProps.name}
        required={selectProps.required}
        disabled={selectProps.disabled}
        onChange={handleSelectChange}
      >
        <option value="" disabled />
        {selectProps.options?.map((option) => (
          <option key={option.countryCode} value={option.dailingCode}>
            {option.countryCode} ({option.dailingCode})
          </option>
        ))}
      </Select>
      <Input
        $baseStyle={inputStyle}
        $error={txtProps.errors}
        type={txtProps.type}
        required={txtProps.required}
        disabled={txtProps.disabled}
        value={txtProps.value}
        onChange={handleTxtChange}
        onBlur={(e) => {
          if (txtProps.errors === null) return runTxtValidation(e);
        }}
      />
      {txtProps.errors && (
        <Span $baseStyle={errorTxt}>{txtProps.errors}</Span>
      )}
    </Container>
  );
};

export default PhoneNumberInput;
